// Expanded list of category icons
import {
  Coffee, Utensils, Leaf, Soup, Sandwich, Cookie, GlassWater, Package,
  Apple, Beef, Cake, Candy, Carrot, Cherry, Citrus, Croissant, Drumstick,
  Egg, Fish, Grape, IceCream, Milk, Pizza, Popcorn, Salad, Wine, Beer,
  CupSoda, Martini, ChefHat, UtensilsCrossed, Store, ShoppingBasket,
  Wheat, Banana
} from 'lucide-react';

// Using available lucide icons that work
export const categoryIcons = [
  { value: 'Coffee', label: 'Coffee/Hot Drinks', icon: Coffee },
  { value: 'Utensils', label: 'Main Meals', icon: Utensils },
  { value: 'UtensilsCrossed', label: 'Hot Food', icon: UtensilsCrossed },
  { value: 'Leaf', label: 'Vegetarian', icon: Leaf },
  { value: 'Soup', label: 'Soup', icon: Soup },
  { value: 'Sandwich', label: 'Sandwiches', icon: Sandwich },
  { value: 'Cookie', label: 'Confectionary', icon: Cookie },
  { value: 'GlassWater', label: 'Cold Drinks', icon: GlassWater },
  { value: 'CupSoda', label: 'Soft Drinks', icon: CupSoda },
  { value: 'Cake', label: 'Cakes/Pastries', icon: Cake },
  { value: 'Croissant', label: 'Bakery', icon: Croissant },
  { value: 'Egg', label: 'Breakfast', icon: Egg },
  { value: 'Apple', label: 'Fruit', icon: Apple },
  { value: 'Carrot', label: 'Vegetables', icon: Carrot },
  { value: 'Salad', label: 'Salads', icon: Salad },
  { value: 'Pizza', label: 'Pizza', icon: Pizza },
  { value: 'Fish', label: 'Fish/Seafood', icon: Fish },
  { value: 'Beef', label: 'Meat', icon: Beef },
  { value: 'Drumstick', label: 'Poultry', icon: Drumstick },
  { value: 'IceCream', label: 'Ice Cream/Desserts', icon: IceCream },
  { value: 'Candy', label: 'Sweets', icon: Candy },
  { value: 'Popcorn', label: 'Snacks', icon: Popcorn },
  { value: 'Wine', label: 'Wine', icon: Wine },
  { value: 'Beer', label: 'Beer', icon: Beer },
  { value: 'Martini', label: 'Cocktails', icon: Martini },
  { value: 'Milk', label: 'Dairy', icon: Milk },
  { value: 'Wheat', label: 'Grains/Cereals', icon: Wheat },
  { value: 'ChefHat', label: 'Specials', icon: ChefHat },
  { value: 'Store', label: 'Retail', icon: Store },
  { value: 'ShoppingBasket', label: 'Groceries', icon: ShoppingBasket },
  { value: 'Package', label: 'Other', icon: Package },
];

export const iconMap = {
  Coffee, Utensils, UtensilsCrossed, Leaf, Soup, Sandwich, Cookie, GlassWater,
  CupSoda, Cake, Croissant, Egg, Apple, Carrot, Salad, Pizza, Fish, Beef,
  Drumstick, IceCream, Candy, Popcorn, Wine, Beer, Martini, Milk, Wheat,
  ChefHat, Store, ShoppingBasket, Package, Banana, Cherry, Citrus, Grape
};

export const getIcon = (iconName) => {
  return iconMap[iconName] || Package;
};
